import { render } from "./WarningSellersEmpty.vue?vue&type=template&id=258fc6ba"
import script from "./WarningSellersEmpty.vue?vue&type=script&lang=js"
export * from "./WarningSellersEmpty.vue?vue&type=script&lang=js"

import "./WarningSellersEmpty.vue?vue&type=style&index=0&id=258fc6ba&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__